import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "image", "ratio"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r } from "react/jsx-runtime";
import { i as n, c as m } from "../utils-NCUO6j8v.js";
import { ImageRatio as s } from "./ImageRatio.js";
const l = _ref => {
  let {
      children: o,
      image: t,
      ratio: e
    } = _ref,
    i = _objectWithoutProperties(_ref, _excluded);
  if (e == "auto") {
    var _t$asset;
    if (!(t !== null && t !== void 0 && (_t$asset = t.asset) !== null && _t$asset !== void 0 && _t$asset._id) || !n(t)) return null;
    const a = m(t);
    return /* @__PURE__ */r(s, _objectSpread(_objectSpread(_objectSpread({
      ratio: "auto"
    }, i), a), {}, {
      children: o
    }));
  } else return /* @__PURE__ */r(s, _objectSpread(_objectSpread({
    ratio: e
  }, i), {}, {
    children: o
  }));
};
export { l as SanityImageRatio };